<script >import { createEventDispatcher } from "svelte";
;
import { codejar } from "../actions/codejar";
const dispatch = createEventDispatcher();
export let element = undefined;
let _class = undefined;
export let style = undefined;
export { _class as class };
export let addClosing = true;
export let catchTab = true;
export let history = true;
export let indentOn = /{$/;
export let preserveIdent = true;
export let spellcheck = false;
export let tab = "\t";
export let withLineNumbers = undefined;
export let highlight = undefined;
export let syntax = undefined;
export let value = "";
function onUpdate(new_value) {
    value = new_value;
    dispatch("change", { value: new_value });
}
</script>

<!-- prettier-ignore -->
<pre
    bind:this={element}
    class="{syntax ? `language-${syntax}` : ''} {_class ?? ''}"
    style={style ? style : ""}
    use:codejar={{
        addClosing,
        catchTab,
        highlight,
        history,
        indentOn,
        onUpdate,
        preserveIdent,
        spellcheck,
        syntax,
        tab,
        value,
        withLineNumbers
    }}><code class={syntax ? `language-${syntax}` : ''}>{#if highlight}{@html highlight(value, syntax)}{:else}{value}{/if}</code></pre>
